// Même règle que CommonServices/Account/ContactFields.NormalizePhone côté API : la colonne Clients.Phone
// fait 15 caractères, et un espace collé avec le numéro faisait refuser toute la location.
export const PHONE_MAX_LENGTH = 15;

export const INVALID_PHONE_MESSAGE = "Veuillez renseigner un numéro de téléphone valide (ex. 06 12 34 56 78).";

// « +33 (0)6 12 34 56 78 » -> « +33612345678 », « 06.12.34.56.78 » -> « 0612345678 », « 0033… » -> « +33… ».
// Une saisie sans chiffre (« NULL » sur d'anciens clients) est seulement débarrassée de ses espaces.
export function normalizePhone(value) {
    if (value === null || value === undefined) {
        return "";
    }

    const raw = String(value);
    let compact = raw.replace("(0)", "").replace(/[^\d+]/g, "");
    if (compact.startsWith("00")) {
        compact = "+" + compact.slice(2);
    }

    return compact || raw.trim();
}

export function isPhoneTooLong(value) {
    return normalizePhone(value).length > PHONE_MAX_LENGTH;
}
